module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAUCAIAAAD6C3GtAAAAUklEQVRIx2MoXXWbdohh1PThaPrS489phxj+0xKQZvqPj69pZfq7iys+b/MEkrQy/es2d1qZDgTHpubSKmR+fft6/+hG0kynbYocLQlGTScRAQC2EpT0HdBODQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ar.png
// module id = 769
// module chunks = 0